export const generateLink = (path) => {
  const isProd = ['app.hosman.co', 'admin.hosman.co'].includes(window.location.host)
  let url = `${location.origin.replace('app.', '').replace('admin.', '')}${path}`
  if (isProd) url = url.replace('hosman.co', 'www.hosman.co')

  return url
}
